export const GAME_CARD_CONFIG = {
  // ======================== 国内 ============================== //
  // U2
  '/cnee': {
    id: 100,
    alias: 100,
    usdkId: 2174,
    path: '/cnee',
    name: '星际52区-英雄游戏官方充值中心',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.hero.rpg.xj52q'],
    wechatInnerUrlIOS: ['https://eecn.yingxiong.com/'],
    wechatOuterUrlAND: ['usdk-com.hero.idle.official.u2'],
    isShowHomeEntry: true
  },
  // 国内创魔
  '/cncm': {
    id: 102,
    alias: 102,
    usdkId: 1016,
    path: '/cncm',
    name: '创造与魔法-英雄游戏官方充值中心',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.hero.sm.ios.hero'],
    wechatInnerUrlIOS: ['https://sm.yingxiong.com/'],
    wechatOuterUrlAND: ['usdk-com.hero.sm.android.hero']
  },
  // 国内文明重启 王牌
  '/wpzz': {
    id: 103,
    alias: 103,
    usdkId: 1058,
    path: '/wpzz',
    name: '文明重启-英雄游戏官方充值中心',
    isShowServer: false,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.lastdayrulessurvival.heroios'],
    wechatInnerUrlIOS: ['https://hero.yingxiong.com/'],
    wechatOuterUrlAND: ['usdk-com.yingxiong.gw.Android.hero']
  },
  // 灵魂潮汐
  '/lhcx': {
    id: 101,
    alias: 101,
    usdkId: 1124,
    path: '/lhcx',
    name: '灵魂潮汐-英雄游戏官方充值中心',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['com.glkj.lhcx.apple'],
    wechatInnerUrlIOS: ['https://lhcx.iqigame.net/'],
    wechatOuterUrlAND: ['com.glkj.lhcx.gf']
  },
  // sample
  '/sampleInternal': {
    id: 104,
    alias: 104,
    usdkId: 100,
    path: '/sampleInternal',
    name: 'sample-英雄游戏官方充值中心',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: [],
    wechatInnerUrlIOS: [],
    wechatOuterUrlAND: []
  },
  // ======================== 海外 ============================== //
  // u2 美国
  '/ee': {
    id: 4,
    alias: 4,
    usdkId: 2222,
    path: '/ee',
    name: 'Eternal Evolution',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.redtide2', 'usdk-com.herogame.ios.eternalevolution'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.eternalevolution.idlerpg', 'usdk-com.herogame.redtide2.huawei']
  },
  // 枪4
  '/lios': {
    id: 6,
    alias: 6,
    usdkId: 2079,
    path: '/lios',
    name: 'Last Island Of Survival',
    email: 'lastdayrulessurvival@gmail.com',
    isShowServer: false,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.lastdayrules'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.lastdayrulessurvival']
  },
  // 枪4 light
  '/lioslite': {
    id: 9,
    alias: 9,
    usdkId: 2258,
    path: '/lioslite',
    name: 'Last Island Of Survival LITE',
    email: 'lioslite@yingxiong.com',
    isShowServer: false,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.lastdayrules'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.survival.lite']
  },
  // u2 台湾  天演进化  // u2 海外
  '/twee': {
    id: 1,
    alias: 1,
    usdkId: 2066,
    path: '/twee',
    name: '天演進化',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.eternalevolution', 'usdk-com.herogame.ios.redtide2'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.eternalevolution.idlerpg', 'usdk-com.herogame.redtide2.huawei']
  },
  // 乌托邦 台湾 (创魔)
  '/twwtb': {
    id: 3,
    alias: 3,
    usdkId: 2048,
    path: '/twwtb',
    name: '烏托邦：起源',
    email: 'utopia@herogame.com',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.herogame.magicminecraft.survival.mmorpg'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.magicminecraft.mmorpg']
  },
  // 小龙2
  '/sd2': {
    id: 8,
    alias: 8,
    usdkId: 2261,
    path: '/sd2',
    name: 'Summon Dragons 2',
    email: 'summondragons2@outlook.com',
    isShowServer: false,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.summondragons.two.idlerpg'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.summondragons.two.idlerpg']
  },
  // 三国志 日本
  '/shinsangokushi': {
    id: 11,
    alias: 11,
    usdkId: 2301,
    //  2272 测试
    path: '/shinsangokushi',
    name: '新三國志',
    email: 'cs@shinsangokushi.com',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: []
  },
  // 三国志 日本
  '/shinsangokushinew': {
    id: 11,
    alias: 11,
    usdkId: 2301,
    //  2272 测试
    path: '/shinsangokushinew',
    name: '新三國志',
    email: 'cs@shinsangokushi.com',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: []
  },
  '/sampleglobal': {
    id: 5,
    alias: 5,
    usdkId: 0,
    path: '/sampleglobal',
    name: 'Sample',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: []
  }
};

// 获取当前游戏配置
export const getGameConfigById = function (alias) {
  return GAME_CARD_CONFIG[alias] || {};
};

// 路由配置 '/lhcx'下架
export const RouteConfig = ['/lios', '/ee', '/twee', '/twwtb', '/dhtw', '/sd2', '/lioslite', '/cnee', '/cncm', '/wpzz', '/sampleInternal', '/sampleglobal', '/shinsangokushi', '/shinsangokushinew'];

// 游戏关联的pcode   '/lhcx': 10160 下架
export const GAME_PCODE_CONFIG = {
  '/cnee': 17234,
  '/cncm': 10031,
  '/wpzz': 10084
};

// 海外商品类型
export const GOODS_TYPE_NAME = {
  1: 'i18n-token',
  2: 'i18n-gift-pack',
  3: 'i18n-subscribe',
  4: 'i18n-welfare'
};

// 只显示日语的游戏
export const ONLY_SHOW_JAPAN = ['/shinsangokushinew', '/shinsangokushi'];

// 不允许购买的游戏
export const NOT_ALLOWED_BUY_PC = ['/cncm'];